import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ScrollMagic from 'scrollmagic';
import isFunction from 'lodash/isFunction';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

let SM;
function initScrollMagic() {
  if (ScrollMagic && ScrollMagic.Controller && ScrollMagic.Scene) {
    SM = ScrollMagic;
  } else {
    SM = {
      Controller: function Controller() {
        return this;
      },
      Scene: function Scene() {
        return this;
      },
    };
  }
  if (isFunction(ScrollMagicPluginGsap)) {
    ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  }
}

const ScrollAnimation = ({
  tween,
  triggerElement,
  triggerHook,
  enterHook,
  reverse,
  children,
  ...scrollmagicProps
}) => {
  initScrollMagic();
  const controller = new SM.Controller();

  useEffect(() => {
    new SM.Scene({
      reverse,
      triggerElement,
      triggerHook,
      ...scrollmagicProps,
    })
      .setTween(tween)
      .addTo(controller)
      .on('enter', enterHook);
  }, []);

  return <section>{children}</section>;
};

ScrollAnimation.propTypes = {
  tween: PropTypes.object.isRequired,
  triggerElement: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
  enterHook: PropTypes.func,
  triggerHook: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ScrollAnimation.defaultProps = {
  triggerHook: 'onEnter',
  reverse: false,
  enterHook: () => {},
};
export default ScrollAnimation;
